import type {StudioConfig} from '@teemill/modules/studio';

export const standardConfig: StudioConfig = {
  output: 'buy',
  context: 'frontend',
  helpPopupName: null,
  enableShareTool: true,
  showFirstTimeTooltips: false,
  defaultDesignTab: 'designs',
  saveTemplate: false,
  uploadDesignsToCloud: false,
  enableBackPrints: true,
  enableProProducts: true,
  enableProDesigns: true,
  enableCustomiseItFeature: true,
  internalUser: false,
  customProductTermsAndConditionsUrl: '/terms-of-sale/',
};

export const bulkPurchaseConfig: StudioConfig = {
  ...standardConfig,
  output: 'bulk-buy',
};
